<h1 mat-dialog-title>
    {{(data.title || 'Manage Attachments') | translate}}
</h1>

    <div mat-dialog-content class="material">
        <div align="right" class="search">
            <mat-form-field class="date-range-field smallBtnField">
                <mat-label>{{'Enter a date range' | translate}}</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate [(ngModel)]="selectedStartdate" placeholder="{{'Start' | translate}} {{'date' | translate}}" readonly>
                    <input matEndDate [(ngModel)]="selectedEnddate" placeholder="{{'End'| translate}} {{'date' | translate}}" readonly>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker (closed)="selectDateRange()"></mat-date-range-picker>
                <button *ngIf="selectedStartdate || selectedEnddate" mat-icon-button matSuffix
                    (click)="clearDateRange($event)" matTooltip="{{'Clear' | translate}}" style="color: #203851;"
                    class="small-icon-button">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field class="search-field">
                <input matInput (input)="search($event.target)" [placeholder]="'Search' | translate">
            </mat-form-field>
            <button mat-raised-button color="primary" (click)="add()" style="margin-left: 2vw;"  *ngIf="!editMode">
                {{'Upload' | translate}}
            </button>
        </div>
        <div *ngIf="!allDocs.results?.length && !loading" style="text-align: center; margin-top: 4vh;">
            {{'No record uploaded' | translate}}
        </div>
        <div fxFlex class="container" fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="0.5vw"
            *ngIf="allDocs.results?.length" fxLayoutAlign="start start">
            <div fxFlex *ngFor="let item of allDocs.results" class="document" fxGrow="0"
                fxLayout="column" fxLayoutAlign="center center" [class.selectedFile]="!editMode && selectedFiles.includes(item._id)" (click)="selectItem(item)">
                <ng-container *ngIf="item.type == 'file'">
                    <div fxFlex="80" class="content-wrapper" fxLayout="column" fxLayoutAlign="center center">
                        <div fxFlex  class="doc-holder">
                            <mat-icon class="default-icon" [matTooltip]="item.name"
                                *ngIf="item.extension != '.pdf'">description</mat-icon>
                            <mat-icon class="default-icon" [matTooltip]="item.name"
                                *ngIf="item.extension == '.pdf'">picture_as_pdf</mat-icon>
                        </div>
                        <mat-icon class="close-icon" (click)="delete($event, item._id)"
                            [matTooltip]="'Delete' | translate" *ngIf="!editMode">delete</mat-icon>
                        <mat-icon class="view-icon" (click)="openDialog($event, item)"
                            [matTooltip]="'View' | translate" *ngIf="!editMode">visibility</mat-icon>
                        <mat-icon class="select-icon" (click)="toggleSelect($event, item)" *ngIf="!editMode"
                            [matTooltip]="(selectedFiles.includes(item._id) ? 'Deselect' : 'Select') | translate">
                            {{ selectedFiles.includes(item._id) ? 'check_box' : 'check_box_outline_blank' }}
                        </mat-icon>
                    </div>
                    <div class="file-info">
                        <span class="file-name-with-extension" title="{{item.name}}">{{item.name | truncate: ['25', '...']}}</span>
                        <span class="file-name" title="{{item.description}}">{{item.description | truncate: ['25','...']}}</span>
                        <span class="file-date" *ngIf="item.createdAt">{{item.createdAt | date:'yyyy/MM/dd HH:mm'}}</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="item.type=='image'">
                    <div fxFlex="80" class="content-wrapper" fxLayout="column" fxLayoutAlign="center center">
                        <div fxFlex class="doc-holder">
                            <img [src]="item.url" [matTooltip]="item.name" />
                        </div>
                        <mat-icon class="close-icon" (click)="delete($event, item._id)"
                            [matTooltip]="'Delete' | translate" *ngIf="!editMode">delete</mat-icon>
                        <mat-icon class="view-icon" (click)="openDialog($event, item)"
                            [matTooltip]="'View' | translate" *ngIf="!editMode">visibility</mat-icon>
                        <mat-icon class="select-icon" (click)="toggleSelect($event, item)" *ngIf="!editMode"
                            [matTooltip]="(selectedFiles.includes(item._id) ? 'Deselect' : 'Select') | translate">
                            {{ selectedFiles.includes(item._id) ? 'check_box' : 'check_box_outline_blank' }}
                        </mat-icon>
                    </div>
                    <div class="file-info">
                        <span class="file-name-with-extension" title="{{item.name}}">{{item.name | truncate: ['25', '...']}}</span>
                        <span class="file-name" title="{{item.description}}">{{item.description | truncate: ['25','...']}}</span>
                        <span class="file-date" *ngIf="item.createdAt">{{item.createdAt | date:'yyyy/MM/dd HH:mm'}}</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="item.type == 'audio'">
                    <div fxFlex="80" class="content-wrapper" fxLayout="column" fxLayoutAlign="center center">
                        <div fxFlex  class="doc-holder">
                            <mat-icon class="default-icon" [matTooltip]="item.name">audio_file</mat-icon>
                        </div>
                        <mat-icon class="close-icon" (click)="delete($event, item._id)"
                            [matTooltip]="'Delete' | translate" *ngIf="!editMode">delete</mat-icon>
                        <mat-icon class="view-icon" (click)="openDialog($event, item)"
                            [matTooltip]="'View' | translate" *ngIf="!editMode">visibility</mat-icon>
                        <mat-icon class="select-icon" (click)="toggleSelect($event, item)" *ngIf="!editMode"
                            [matTooltip]="(selectedFiles.includes(item._id) ? 'Deselect' : 'Select') | translate">
                            {{ selectedFiles.includes(item._id) ? 'check_box' : 'check_box_outline_blank' }}
                        </mat-icon>
                    </div>
                    <div class="file-info">
                        <span class="file-name-with-extension" title="{{item.name}}">{{item.name | truncate: ['25', '...']}}</span>
                        <span class="file-name" title="{{item.description}}">{{item.description | truncate: ['25','...']}}</span>
                        <span class="file-date" *ngIf="item.createdAt">{{item.createdAt | date:'yyyy/MM/dd HH:mm'}}</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="item.type == 'video'">
                    <div fxFlex="80" class="content-wrapper" fxLayout="column" fxLayoutAlign="center center">
                        <div fxFlex class="doc-holder">
                            <mat-icon class="default-icon" [matTooltip]="item.name">video_file</mat-icon>
                        </div>
                        <mat-icon class="close-icon" (click)="delete($event, item._id)"
                            [matTooltip]="'Delete' | translate" *ngIf="!editMode">delete</mat-icon>
                        <mat-icon class="view-icon" (click)="openDialog($event, item)"
                            [matTooltip]="'View' | translate" *ngIf="!editMode">visibility</mat-icon>
                        <mat-icon class="select-icon" (click)="toggleSelect($event, item)" *ngIf="!editMode"
                            [matTooltip]="(selectedFiles.includes(item._id) ? 'Deselect' : 'Select') | translate">
                            {{ selectedFiles.includes(item._id) ? 'check_box' : 'check_box_outline_blank' }}
                        </mat-icon>
                    </div>
                    <div class="file-info">
                        <span class="file-name-with-extension" title="{{item.name}}">{{item.name | truncate: ['25', '...']}}</span>
                        <span class="file-name" title="{{item.description}}">{{item.description | truncate: ['25','...']}}</span>
                        <span class="file-date" *ngIf="item.createdAt">{{item.createdAt | date:'yyyy/MM/dd HH:mm'}}</span>
                    </div>
                </ng-container>
            </div>
        </div>
        <!-- <mat-paginator #allPaginator [pageSizeOptions]="[10,20,30]" [showFirstLastButtons]="true"
            [hidden]="!allDocs.pagination?.total || loading" (page)="getDocuments($event)"
            [pageIndex]="pageIndexAll" [pageSize]="pageSizeAll">
        </mat-paginator> -->
    </div>

    <div mat-dialog-actions>
        <div fxLayout="row" fxFlex fxLayoutGap="0px">
            <div fxFlex align="left">
                <mat-paginator class="demo-paginator" #allPaginator [pageSizeOptions]="[10,20,30]" [showFirstLastButtons]="true"
                    [hidden]="!allDocs.pagination?.total || loading" (page)="getDocuments($event)"
                    [pageIndex]="pageIndexAll" [pageSize]="pageSizeAll">
                </mat-paginator>
            </div>
            <div fxFlex align="right">
                <button type="button" class="green-text" mat-raised-button (click)="confirm()" *ngIf="!editMode"
                    [disabled]="selectedFiles.length == 0">{{'Confirm' | translate}}
                </button>
                <button *ngIf="!editMode" type="button" class="red-text" mat-raised-button mat-dialog-close (click)="close()">
                    {{ "Cancel" | translate }}
                </button>
                <button *ngIf="editMode" type="button" class="red-text" mat-raised-button mat-dialog-close (click)="close()">
                    {{ "Close" | translate }}
                </button>
            </div>
        </div>
    </div>